/**
 * AI Recruit - Source API Service
 * API calls for job and resume source management
 */

import { apiV2 } from './api'

export interface Source {
  id: string
  organization_id: string
  name: string
  is_active: boolean
  created_at: string
  updated_at: string
  created_by_id?: string
}

export interface SourceListResponse {
  sources: Source[]
  total: number
}
/**
 * Fetch sources for a specific type (job or resume)
 */
export const fetchSources = async (type: 'job' | 'resume', includeInactive = false): Promise<Source[]> => {
  const endpoint = type === 'job' ? '/sources/jobs' : '/sources/resumes'
  const response = await apiV2.get<SourceListResponse>(endpoint, {
    params: { include_inactive: includeInactive }
  })
  return response.data.sources
}

/**
 * Create a new source
 */
export const createSource = async (type: 'job' | 'resume', name: string): Promise<Source> => {
  const endpoint = type === 'job' ? '/sources/jobs' : '/sources/resumes'
  const response = await apiV2.post<Source>(endpoint, { name })
  return response.data
}

/**
 * Update a source name
 */
export const updateSource = async (
  type: 'job' | 'resume',
  sourceId: string,
  name: string
): Promise<Source> => {
  const endpoint = type === 'job' ? `/sources/jobs/${sourceId}` : `/sources/resumes/${sourceId}`
  const response = await apiV2.put<Source>(endpoint, { name })
  return response.data
}

/**
 * Deactivate a source
 */
export const deactivateSource = async (type: 'job' | 'resume', sourceId: string): Promise<Source> => {
  const endpoint = type === 'job' 
    ? `/sources/jobs/${sourceId}/deactivate` 
    : `/sources/resumes/${sourceId}/deactivate`
  const response = await apiV2.post<Source>(endpoint)
  return response.data
}

/**
 * Activate a source
 */
export const activateSource = async (type: 'job' | 'resume', sourceId: string): Promise<Source> => {
  const endpoint = type === 'job' 
    ? `/sources/jobs/${sourceId}/activate` 
    : `/sources/resumes/${sourceId}/activate`
  const response = await apiV2.post<Source>(endpoint)
  return response.data
}
